import React from 'react';
import { MapPin, Truck } from 'lucide-react';
import { tx } from '@/translations/translations';

export const CartShippingBadges = ({ language, qualifiesFreeShipping, itemCount, itemsToFreeShipping, freeShippingThreshold }) => (
  <div className="space-y-2.5">
    <div className="flex items-center gap-2.5 bg-gradient-to-r from-cyan-50 to-blue-50 border border-cyan-200 rounded-xl px-3 py-2.5">
      <div className="w-8 h-8 rounded-full bg-cyan-500 flex items-center justify-center flex-shrink-0">
        <MapPin className="w-4 h-4 text-white" />
      </div>
      <div>
        <p className="text-xs font-bold text-cyan-700">
          {tx(language, 'Envío a Domicilio', 'Home Delivery', 'משלוח עד הבית')}
        </p>
        <p className="text-[11px] text-cyan-600/70">
          {tx(language, 'CDMX y Edo. de México · 24-48 hrs', 'CDMX & Estado de México · 24-48 hrs', 'מקסיקו סיטי והמדינה · 24-48 שעות')}
        </p>
      </div>
    </div>

    {qualifiesFreeShipping ? (
      <div className="flex items-center gap-2.5 bg-gradient-to-r from-green-50 to-emerald-50 border border-green-200 rounded-xl px-3 py-2.5">
        <div className="w-8 h-8 rounded-full bg-green-500 flex items-center justify-center flex-shrink-0">
          <Truck className="w-4 h-4 text-white" />
        </div>
        <p className="text-xs font-bold text-green-700">
          {tx(language, 'Envío gratis aplicado', 'Free shipping applied', 'משלוח חינם הופעל')}
        </p>
      </div>
    ) : (
      <div className="bg-slate-50 border border-slate-200 rounded-xl px-3 py-2.5">
        <div className="flex items-center justify-between mb-1.5">
          <p className="text-[11px] font-semibold text-slate-700">
            {tx(language,
              `Agrega ${itemsToFreeShipping} ${itemsToFreeShipping === 1 ? 'producto' : 'productos'} más para envío gratis`,
              `Add ${itemsToFreeShipping} more product${itemsToFreeShipping === 1 ? '' : 's'} for free shipping`,
              `הוסיפו עוד ${itemsToFreeShipping} למשלוח חינם`)}
          </p>
          <span className="text-[10px] font-bold text-cyan-600">{itemCount}/{freeShippingThreshold}</span>
        </div>
        <div className="h-1.5 bg-slate-200 rounded-full overflow-hidden">
          <div
            className="h-full bg-gradient-to-r from-cyan-500 to-emerald-500 transition-all duration-500"
            style={{ width: `${Math.min(100, (itemCount / freeShippingThreshold) * 100)}%` }}
          />
        </div>
      </div>
    )}
  </div>
);
